// Centralized content for Tsalach Cleaning Services
import { Home, Building2, Key, Sparkles, Package, Hammer, Wind, Layers } from 'lucide-react';

export const COMPANY = {
  name: 'Tsalach Cleaning Services',
  tagline: 'Clean Spaces. Healthy Places. Happy Faces.',
  phones: ['(571) 265-6239'],
  email: 'Tsalach7LLC@gmail.com',
  serviceArea: 'Washington DC · Maryland · Virginia',
};

export const SERVICES = [
  {
    id: 'residential',
    name: 'Residential',
    short: 'Homes',
    desc: 'Bespoke home cleaning crafted for the way you live.',
    icon: Home,
    features: ['Deep cleaning', 'Weekly maintenance', 'Eco-friendly products', 'Pet-safe formulas'],
    image: 'https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?w=1200&q=80&auto=format&fit=crop',
  },
  {
    id: 'commercial',
    name: 'Commercial',
    short: 'Offices',
    desc: 'Spotless workplaces that elevate productivity and brand.',
    icon: Building2,
    features: ['Daily janitorial', 'Floor & carpet care', 'Restroom sanitation', 'Window service'],
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80&auto=format&fit=crop',
  },
  {
    id: 'airbnb',
    name: 'Airbnb',
    short: 'Turnovers',
    desc: 'Five-star turnovers that keep your reviews — and ratings — pristine.',
    icon: Key,
    features: ['Same-day turnover', 'Linen & laundry', 'Restock essentials', 'Quality inspection'],
    image: 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=1200&q=80&auto=format&fit=crop',
  },
  {
    id: 'deep',
    name: 'Deep Clean',
    short: 'Detailed',
    desc: 'A full reset for your space — every corner, edge, and surface.',
    icon: Sparkles,
    features: ['Top-to-bottom', 'Hard-to-reach areas', 'Grout & tile', 'Inside appliances'],
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1200&q=80&auto=format&fit=crop',
  },
  {
    id: 'movein',
    name: 'Move In/Out',
    short: 'Transitions',
    desc: 'Walk into a flawless home — or hand back deposits in full.',
    icon: Package,
    features: ['Full property clean', 'Cabinet interiors', 'Wall spot-clean', 'Deposit-ready'],
    image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=1200&q=80&auto=format&fit=crop',
  },
  {
    id: 'postcon',
    name: 'Post-Construction',
    short: 'Finishing',
    desc: 'Specialized cleanup that turns a finished build into a livable home.',
    icon: Hammer,
    features: ['Dust removal', 'Paint & residue', 'Final polish', 'Debris haul-out'],
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80&auto=format&fit=crop',
  },
  {
    id: 'windows',
    name: 'Window Cleaning',
    short: 'Crystal Clear',
    desc: 'Streak-free interiors and exteriors — let the light back in.',
    icon: Wind,
    features: ['Interior & exterior', 'Streak-free finish', 'Screen wipe-down', 'Sill & track detail'],
    image: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?w=1200&q=80&auto=format&fit=crop',
  },
  {
    id: 'carpet',
    name: 'Carpet Cleaning',
    short: 'Deep Restore',
    desc: 'Hot-water extraction that lifts years of wear from every fiber.',
    icon: Layers,
    features: ['Hot-water extraction', 'Stain treatment', 'Pet odor removal', 'Fast dry times'],
    image: 'https://images.unsplash.com/photo-1558317374-067fb5f30001?w=1200&q=80&auto=format&fit=crop',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Alexandra Morrison',
    title: 'Georgetown Residence',
    text: "Tsalach has cleaned our home for two years. Their attention to detail is extraordinary — every visit feels like coming home for the first time.",
    rating: 5,
    initials: 'AM',
  },
  {
    name: 'David Chen',
    title: 'TechHub Offices · DC',
    text: 'Managing a 50-person office means cleanliness matters every single day. Tsalach delivers a perfect workplace, every morning.',
    rating: 5,
    initials: 'DC',
  },
  {
    name: 'Sarah Williams',
    title: 'Luxury Airbnb Host',
    text: 'My properties hold five-star ratings because of the team at Tsalach. Lightning turnovers, immaculate results, every single time.',
    rating: 5,
    initials: 'SW',
  },
  {
    name: 'Marcus Patel',
    title: 'Reston, VA Homeowner',
    text: "I've used three cleaning services. Tsalach is in a league of their own — punctual, thorough, and genuinely lovely people.",
    rating: 5,
    initials: 'MP',
  },
];

export const GALLERY = [
  { src: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=900&q=80&auto=format&fit=crop', label: 'Marble Kitchen', span: 'tall' },
  { src: 'https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?w=900&q=80&auto=format&fit=crop', label: 'Living Room', span: 'short' },
  { src: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=900&q=80&auto=format&fit=crop', label: 'Spa Bathroom', span: 'short' },
  { src: 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=900&q=80&auto=format&fit=crop', label: 'Master Suite', span: 'tall' },
  { src: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=900&q=80&auto=format&fit=crop', label: 'Open Office', span: 'short' },
  { src: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=900&q=80&auto=format&fit=crop', label: 'Hardwood Floors', span: 'tall' },
  { src: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80&auto=format&fit=crop', label: 'Modern Estate', span: 'short' },
  { src: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=900&q=80&auto=format&fit=crop', label: 'Designer Suite', span: 'tall' },
];

export const PROPERTY_SIZES = [
  { id: 'small', label: 'Small', sub: 'Under 1,000 sq ft' },
  { id: 'medium', label: 'Medium', sub: '1,000 – 2,500 sq ft' },
  { id: 'large', label: 'Large', sub: '2,500 – 5,000 sq ft' },
  { id: 'xl', label: 'Estate', sub: 'Over 5,000 sq ft' },
];

export const PROPERTY_TYPES = [
  { id: 'home', label: 'Residential Home', icon: Home },
  { id: 'office', label: 'Commercial Office', icon: Building2 },
  { id: 'airbnb', label: 'Airbnb Property', icon: Key },
  { id: 'other', label: 'Something Else', icon: Sparkles },
];
